import { useHedinUIContext } from "../../base/helpers/useHedinUIContext";
export default function useTranslation() {
  var _ctx$i18nInstance$loc, _ctx$i18nInstance, _ctx$i18nInstance$loc2, _fallback, _ctx$i18nInstance$t$b, _ctx$i18nInstance2;
  var ctx = useHedinUIContext();

  // The .slice(0, 2) is a hack to make it work with retail-nextjs (where the locale is originally e.g. sv-SE, but sliced)
  var locale = ((_ctx$i18nInstance$loc = ctx === null || ctx === void 0 || (_ctx$i18nInstance = ctx.i18nInstance) === null || _ctx$i18nInstance === void 0 || (_ctx$i18nInstance$loc2 = _ctx$i18nInstance.locale) === null || _ctx$i18nInstance$loc2 === void 0 ? void 0 : _ctx$i18nInstance$loc2.call(_ctx$i18nInstance)) !== null && _ctx$i18nInstance$loc !== void 0 ? _ctx$i18nInstance$loc : 'sv-SE').slice(0, 2);

  // Retrieve fallback translations given current locale. If no fallback is found, use empty object.
  var fb = (_fallback = fallback[locale]) !== null && _fallback !== void 0 ? _fallback : {};

  // Fallback translations function. If no fallback value is found, use empty string.
  var tFb = function tFb(key) {
    var _fb;
    return (_fb = fb[key]) !== null && _fb !== void 0 ? _fb : '';
  };

  // Create a translation function that uses i18next.t(), use fallback function if i18next is not available.
  var t = (_ctx$i18nInstance$t$b = ctx === null || ctx === void 0 || (_ctx$i18nInstance2 = ctx.i18nInstance) === null || _ctx$i18nInstance2 === void 0 ? void 0 : _ctx$i18nInstance2.t.bind(ctx.i18nInstance)) !== null && _ctx$i18nInstance$t$b !== void 0 ? _ctx$i18nInstance$t$b : tFb;

  /**
   * @param key - The translation key
   * @param variable - The variable to replace {1} with
   */
  // Return translation function that replaces {1} with variable. If there is no value for key, use fallback function.
  return function (key) {
    var variable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '{1}';
    return ((t([key]) !== key ? t([key]) : tFb(key)) || tFb(key)).replace('{1}', variable);
  };
}

// We should probably not have fallback translations, these have just been copied from the former structure.
var fallback = {
  sv: {
    readMore: 'Läs mer',
    searchButton: 'SÖK',
    searchBarPlaceholder: 'Sök på t. ex märke, modell, utrustning eller egenskaper ',
    searchNoResults: 'Din sökning gav 0 träffar, försök igen med en annan sökterm.',
    paginationShowing: 'Visar',
    paginationShowingOf: 'av',
    fieldCanNotBeEmpty: 'Detta fält kan inte vara tomt.',
    fieldHasWrongFormat: 'Detta har felaktigt format.',
    collapseShow: 'Visa',
    collapseHide: 'Dölj',
    uploadFileButton: 'Välj fil',
    findMyLocation: 'Hitta min plats',
    ' is requried': 'saknas'
  }
};